var slide = require('./make-slide'),
	slideOptions = {
		slideUp: function(obj, callback) {
			if (obj.offsetHeight > 0) {
				if (obj.querySelector('.coto_open')) {
					slide(obj.querySelector('.coto_slide-dropdown'), callback);
					obj.querySelector('.coto_open').classList.remove('coto_open');
				}

				return slide(obj, callback);
			}
		},
		slideDown: function(obj, callback) {
			if (obj.offsetHeight == 0) {
				return slide(obj, callback);
			}
		},
		slideToggle:  function(obj, callback) {
			let objHeight = obj.offsetHeight;

			if (objHeight == 0) {
				return this.slideDown(obj, callback);
			} else {
				return this.slideUp(obj, callback);
			}
		}
	};

module.exports = slideOptions;